import React from "react";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Button} from "../index";
import styles from "./VideoPlayer.module.css";

interface EventNotStartedOverlayProps {
    overlay: {
        visible: boolean;
        title?: string;
        poster?: string;
    };
    isSportsContext: boolean;
    onBack: () => void;
}

const EventNotStartedOverlay: React.FC<EventNotStartedOverlayProps> = ({
    overlay,
    isSportsContext,
    onBack,
}) => {
    const {t} = useTranslation("translations");

    if (!overlay.visible) return null;

    return (
        <div
            className={styles.eventNotStartedOverlay}
            style={{backgroundImage: `url(${overlay.poster ?? ""})`}}
        >
            <div className={styles.eventNotStartedOverlayMask} />
            <div className={styles.eventNotStartedOverlayContent}>
                <Typography variant="h1">{overlay.title}</Typography>
                <Typography variant="h3">{t("NotFound.notStarted")}</Typography>
                {isSportsContext && (
                    <Button variant="contained" color="secondary" onClick={onBack}>
                        {t("Buttons.back")}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default EventNotStartedOverlay;
